<script>
import useSharedData from "@/use/SharedData.js";
import {useAbsenceRequestStore} from "@/stores/AbsenceRequest.js";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {computed, ref, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import AbsenceRequestFilter from "@/views/Absence/AbsenceRequest/Components/AbsenceRequestFilter.vue";
import axios from "axios";
import {storeToRefs} from "pinia";

export default {
    props: {
        vacation: Boolean,
        intranet: {
            type: Boolean,
            default: false
        },
    },
    components: {AbsenceRequestFilter},
    setup(props) {
        const {
            loading,
            rightDrawer,
            total,
            filter,
            itemsPerPage
        } = useSharedData();
        const absenceRequestStore = useAbsenceRequestStore();
        const securityStore = useSecurityStore();
        const {$i18n, $router} = useTools();
        const {formatedDate, formatedTime, transformFilterValues} = useSharedMethod();
        
        const rootPath = computed(() => {
            if (props.vacation) {
                return props.intranet ? 'intranet_vacations' : 'vacations';
            } else {
                return props.intranet ? 'intranet_absence_requests' : 'absence_requests';
            }
        });
        
        const headers = ref([
            {
                text: "",
                align: "start",
                sortable: false,
                value: "action",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t("module.worker"),
                align: "start",
                sortable: true,
                value: "workerLastName",
            },
            {
                text: $i18n.t("absence_request.start_date"),
                align: "start",
                sortable: true,
                value: "startDate",
            },
            {
                text: $i18n.t("absence_request.end_date"),
                align: "start",
                sortable: true,
                value: "endDate",
            },
            {
                text: $i18n.t("absence_request.start_time"),
                align: "start",
                sortable: true,
                value: "startTime",
            },
            {
                text: $i18n.t("absence_request.end_time"),
                align: "start",
                sortable: true,
                value: "endTime",
            },
            {
                text: $i18n.t("module.absence_reason"),
                align: "start",
                sortable: true,
                value: "reasonName",
            },
            
            {
                text: $i18n.t("common.days"),
                align: "start",
                sortable: true,
                value: "days",
            },
            {
                text: $i18n.t("common.hours"),
                align: "start",
                sortable: true,
                value: "hours",
            },
            {
                text: $i18n.t("absence_request.calendar_days"),
                align: "start",
                sortable: true,
                value: "calendarDays",
            },
            {
                text: $i18n.t("absence_request.open_days"),
                align: "start",
                sortable: true,
                value: "openDays",
            },
            {
                text: $i18n.t("absence_request.input_mode"),
                align: "start",
                sortable: true,
                value: "inputMode",
            },
            {
                text: $i18n.t("common.validation"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastState",
                width: "0%"
            },
            {
                text: $i18n.t("common.validation_date"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastValidationDate",
                width: "0%"
            },
            {
                text: $i18n.t("common.next_validator"),
                align: "start",
                sortable: true,
                value: "validationStatus.nextValidator",
                width: "0%"
            },
        ]);
        
        const actions = [
            {
                title: $i18n.t('absence_request.vacation_title'),
                icon: 'mdi-cloud-print',
                color: 'teal',
                access: () => props.vacation,
                disabled: (item) => item.validationStatus.status !== 'ACCEPT',
                func: (item) => {
                    $router.push({name: `${rootPath.value}.vacation_title`, params: {id: item.id}});
                },
            },
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: (item) => item.updateOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: (item) => item.deleteOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
        ];
        
        const {itemsToBeValidate} = storeToRefs(securityStore);
        
        const searchParams = ref({
            sortBy: "startDate",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage
        });
        
        function handleSearch(params) {
            loading.value = true;
            absenceRequestStore.setAbsenceRequests([]);
            total.value = 0;
            
            filter.value.itemsToBeValidate = itemsToBeValidate.value;
            if (props.vacation) {
                filter.value.balanceId = securityStore.userContext.vacationBalanceId;
            } else {
                filter.value.notEqualBalanceId = securityStore.userContext.vacationBalanceId;
            }
            
            filter.value.myData = props.intranet;
            
            
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;
            
            axios.get('/absenceRequests', {params: transformFilterValues(filter.value)}).then((response) => {
                absenceRequestStore.setAbsenceRequests(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function findAll() {
            handleSearch(searchParams.value)
        }
        
        watch(() => [filter.value, itemsToBeValidate.value], () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});
        
        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
            itemsToBeValidate.value = false;
        }
        
        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }
        
        
        return {
            rootPath,
            securityStore,
            absenceRequestStore,
            loading,
            rightDrawer,
            total,
            filter,
            headers,
            actions,
            searchParams,
            itemsToBeValidate,
            clearFilter,
            findAll,
            view,
            formatedDate,
            formatedTime
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="vacation ? $t('module.vacation') : $t('module.absence_request')"
            :total="total"
            :show-filter="!intranet"
            :filter="filter"
            @clearFilter="clearFilter"
        >
            
            <template v-slot:filter>
                <absence-request-filter
                    v-model="filter"
                    :vacation="vacation"
                />
            </template>
            
            <template v-slot:leftToolbar>
                <v-checkbox
                    v-if="!intranet"
                    v-model="itemsToBeValidate"
                    :label="$t('common.requests_need_validation')"
                    :true-value="true"
                    :false-value="false"
                    class="ml-2"
                    hide-details
                />
            </template>
            
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['SAVE_ABSENCE_REQUEST']"
                    @press="$router.push({name: `${rootPath}.add`})"
                />
            </template>
            
            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="absenceRequestStore.absenceRequests"
                    :loading="loading"
                    :total="total"
                    show-validation
                    :root-path="rootPath"
                    module="ABSENCE_REQUEST"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text bold :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.startDate`]="{ item }">
                        <w-inline-text :text="formatedDate(item.startDate)"/>
                    </template>
                    <template v-slot:[`item.endDate`]="{ item }">
                        <w-inline-text :text="formatedDate(item.endDate)"/>
                    </template>
                    <template v-slot:[`item.startTime`]="{ item }">
                        <w-inline-text :text="formatedTime(item.startTime)"/>
                    </template>
                    <template v-slot:[`item.endTime`]="{ item }">
                        <w-inline-text :text="formatedTime(item.endTime)"/>
                    </template>
                    <template v-slot:[`item.reasonName`]="{ item }">
                        <w-chip color="teal" :text="item.reasonName"/>
                    </template>
                    <template v-slot:[`item.days`]="{ item }">
                        <w-inline-text :text="item.days.toFixed(2)"/>
                    </template>
                    <template v-slot:[`item.hours`]="{ item }">
                        <w-inline-text :text="item.hours.toFixed(2)"/>
                    </template>
                    <template v-slot:[`item.calendarDays`]="{ item }">
                        <w-inline-text :text="item.calendarDays.toFixed(2)"/>
                    </template>
                    <template v-slot:[`item.openDays`]="{ item }">
                        <w-inline-text :text="item.openDays.toFixed(2)"/>
                    </template>
                    <template v-slot:[`item.inputMode`]="{ item }">
                        <w-inline-text :text="$t(`absence_request.${item.inputMode}`)"/>
                    </template>
                
                </w-server-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>